export const SITE_BRAND = 'Career Grad Global - Study Abroad';

export const SITE_DEFAULT_TITLE = `${SITE_BRAND} | Expert Study Abroad Consultants & Visa Guidance`;

export const SITE_DESCRIPTION =
  'Career Grad Global helps students study abroad with personalized counseling, university applications, scholarships, and visa support across 15+ countries.';

/** Legacy CMS titles that should resolve to the canonical homepage default. */
function isLegacyBrandOnlyTitle(title: string): boolean {
  const normalized = title.replace(/[—–]/g, '-').trim();
  return /^Career Grad(\s*-\s*Study Abroad)?$/i.test(normalized);
}

/** Strips a trailing "| Career Grad" suffix from older CMS page titles. */
function stripLegacyBrandSuffix(title: string): string {
  return title.replace(/\s*\|\s*Career Grad\s*$/i, '').trim();
}

/** Ensures every document title includes the brand; adds SEO context when a page title is provided. */
export function buildPageTitle(pageTitle?: string | null): string {
  const trimmed = pageTitle?.trim();
  if (!trimmed) return SITE_DEFAULT_TITLE;
  if (trimmed.includes('Career Grad Global')) return trimmed;
  if (isLegacyBrandOnlyTitle(trimmed)) return SITE_DEFAULT_TITLE;

  const pagePart = stripLegacyBrandSuffix(trimmed);
  if (!pagePart) return SITE_DEFAULT_TITLE;
  if (isLegacyBrandOnlyTitle(pagePart)) return SITE_DEFAULT_TITLE;

  return `${pagePart} | ${SITE_BRAND}`;
}
